var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top_wrapper" },
    [
      _vm.password_change
        ? _c("div", { staticClass: "password_change" }, [
            _vm._v(
              "\n    パスワードが２ヶ月変更されておりません。安全性のため、変更お願い致します。\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.whatsNewText
        ? _c("div", { staticClass: "whatnew_message u-mt--10" }, [
            _vm._v(_vm._s(_vm.whatsNewText))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCredit
        ? _c("div", { staticClass: "add_user" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.application("credit")
                  }
                }
              },
              [
                _vm._v("\n      カード発行申し込み（信販）\n      "),
                _c("i", { staticClass: "el-icon-bank-card" })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showInstallment
        ? _c("div", { staticClass: "add_cregit" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.application("installment")
                  }
                }
              },
              [
                _vm._v("\n      信用保証申し込み（自社割賦）\n      "),
                _c("i", { staticClass: "far fa-handshake" })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isBranch ? _c("el-divider") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "second", class: { "u-mt--24": !_vm.isBranch } },
        [
          _c(
            "el-row",
            {
              staticClass: "row-bg",
              attrs: { type: "flex", justify: "space-around" }
            },
            [
              _c(
                "el-col",
                {
                  staticClass: "list",
                  staticStyle: { "touch-action": "manipulation" },
                  attrs: { span: 6 }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.list($event)
                        }
                      }
                    },
                    [
                      _vm._v(" ご契約情報一覧"),
                      _c("i", { staticClass: "fas fa-list-ul" })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "list",
                  staticStyle: { "touch-action": "manipulation" },
                  attrs: { span: 6 }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.passwordReset($event)
                        }
                      }
                    },
                    [
                      _vm._v(" パスワード変更"),
                      _c("i", { staticClass: "fas fa-pencil-alt" })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "list",
                  staticStyle: { "touch-action": "manipulation" },
                  attrs: { span: 6 }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.documentDownload($event)
                        }
                      }
                    },
                    [
                      _vm._v(" 各種書類"),
                      _c("span", [_vm._v("※口座振替依頼書、解約書式等")]),
                      _c("i", { staticClass: "el-icon-document" })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact_box" },
        [
          _c(
            "p",
            {
              staticClass:
                "contact_box__basic_text contact_box__basic_text--bold"
            },
            [_vm._v("トリプルクラウン")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "contact_box__basic_text contact_box__basic_text--bold"
            },
            [_vm._v("お申込みに関するお問い合わせ先")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "contact_box__basic_text contact_box__basic_text--bold"
            },
            [_vm._v("TEL 092-292-7544")]
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              attrs: {
                gutter: 20,
                type: "flex",
                justify: "center",
                align: "middle"
              }
            },
            [
              _c("el-col", { staticClass: "text-right", attrs: { span: 11 } }, [
                _c("p", { staticClass: "contact_box__basic_text" }, [
                  _vm._v("営業時間")
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "text-left", attrs: { span: 13 } }, [
                _c("p", { staticClass: "contact_box__basic_text" }, [
                  _vm._v("\n          平　日 9:00〜19:00"),
                  _c("br"),
                  _vm._v(" "),
                  _vm._v("\n          土曜日・日曜・祝日　休業\n        ")
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "contact_box__basic_text" }, [
            _vm._v("※解約に関するお問い合わせは、平日のみの対応となります。")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c(
            "el-timeline",
            _vm._l(_vm.news, function(item, index) {
              return _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: { timestamp: item.timestamp, placement: "top" }
                },
                [
                  _c("el-card", [
                    _c("h4", [
                      item.isNew
                        ? _c("span", { staticClass: "whatnew_new" }, [
                            _vm._v("new")
                          ])
                        : _vm._e(),
                      _vm._v(" " + _vm._s(item.title))
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.changeLink(item.message))
                      }
                    })
                  ])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "whatnew_title" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(" TripleCrownからのお知らせ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }